import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';

import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withOnline from '../../common/withOnline';
import withUpdatedRoute from '../../common/withUpdatedRoute';
import withSurgeonNotes from '../../common/withSurgeonNotes';

import Header from '../../components/Header';
import Bugsnag from '../../helpers/bugsnag';
import {
  sortData,
  storeLastVisitedRoute,
} from '../../common/globals';
import {
  getSurgeonNotes
} from '../../utils/utils';
import {
  getAllSurgeonNotes,
  addBulkSurgeonNotes,
  surgeonNotesClear
} from '../../utils/db';

class SurgeonNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      surgeonNoteData: [],
      originalSurgeonNoteData: [],
      search: ''
    };
  }

  componentDidMount() {
    try {
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getSurgeonNotesData = async () => {
    try {
      const { online, notify } = this.props;
      if (online) {
        const surgeonNoteRes = await getSurgeonNotes();
        const { message, status, data } = surgeonNoteRes;
        if (status) {
          await surgeonNotesClear();
          if (typeof data !== 'undefined' && data !== null) {
            await addBulkSurgeonNotes(data);
          }
          this._fetchLocalSurgeonNotes();
        } else {
          notify({ type: 'error', message });
        }
      } else {
        this._fetchLocalSurgeonNotes();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _fetchLocalSurgeonNotes = async () => {
    try {
      const { setLoader } = this.props;

      const finalSurgeonNoteList = await getAllSurgeonNotes();
      const sortedObjs = sortData(finalSurgeonNoteList, 'SurgeonName');
      this.setState({
        surgeonNoteData: sortedObjs,
        originalSurgeonNoteData: sortedObjs
      });

      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearch = (event) => {
    try {
      let searchTxt = '';
      searchTxt = event.target.value;
      this.setState({ search: searchTxt }, () => {
        this._searchSurgeonNote();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _searchSurgeonNote = () => {
    try {
      const { search, originalSurgeonNoteData } = this.state;
      if (search && search.length > 0) {
        const searchData = search.toUpperCase();
        const searchRes = originalSurgeonNoteData.filter((surgeon) => {
          // Search by SurgeonName
          const surgeonNameMatch = surgeon.SurgeonName
            && surgeon.SurgeonName.toUpperCase().includes(searchData);

          // Search in the notes array
          const notesMatch = surgeon.notes && surgeon.notes.some(
            (note) => (note.NoteTitle && note.NoteTitle.toUpperCase().includes(searchData))
              || (note.Note && note.Note.toUpperCase().includes(searchData))
          );

          // Return true if either the SurgeonName matches or any of the notes match
          return surgeonNameMatch || notesMatch;
        });

        const sortedObjs = sortData(searchRes, 'SurgeonName');
        this.setState({
          surgeonNoteData: sortedObjs
        });
      } else {
        this.setState({
          surgeonNoteData: originalSurgeonNoteData
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddNew = () => {
    try {
      const { goBack, setGoBack, setSurgeonNote } = this.props;
      setSurgeonNote({
        SurgeonName: '',
        NoteTitle: '',
        Note: '',
        ID: ''
      });

      goBack.push(window.location.pathname);
      setGoBack(goBack);
      storeLastVisitedRoute('add');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEditsurgeonNote = (data, name) => {
    try {
      const {
        setSurgeonNote, goBack, setGoBack, online, notify
      } = this.props;

      if (online) {
        setSurgeonNote({ ...data, SurgeonName: name });
        goBack.push(window.location.pathname);
        setGoBack(goBack);
        browserHistory.push(`surgeon-notes/${data.ID}/edit`);
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.',
          time: 3
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { setUpdatedRoute, setLoader, setSurgeonNote } = this.props;
      setLoader(true);
      setSurgeonNote({});
      await this._getSurgeonNotesData();
      storeLastVisitedRoute('/surgeon-notes');
      setUpdatedRoute('/surgeon-notes');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { surgeonNoteData, search } = this.state;
    return (
      <section className="list-section">
        <Header
          sideMenu
          goForward={{
            title: 'Add <i class="fas fa-plus"></i></a>',
            url: '/surgeon-notes/add',
            onGoForward: this._onAddNew,
            showIcon: true
          }}
        />
        <section className="sets-section">
          <div className="container resizer-class">
            <div className="top-block sticky-pref-search">
              <div className="row gx-2">
                <div className="col-12 pt-2 pb-2">
                  <input
                    type="text" className="form-control search-input x-ray-choose-file"
                    placeholder="Search Surgeon Notes"
                    onChange={(e) => this._onSearch(e)}
                    value={search}
                  />
                </div>
              </div>
            </div>

            <div className="sets-list-blocks t-b-border-0 p-0">

              {
                surgeonNoteData.length > 0
                  ? surgeonNoteData.map((item, index) => (
                    <div className="sets-block" key={index + 1}>
                      <div
                        className="row gx-3 cursor-pointer bd-b-gray"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${index + 1}`}
                        style={{ borderBottom: '1px solid #666' }}
                      >
                        <div className="col">
                          <p className="m-3">{item.SurgeonName} ({item.notes.length}) </p>
                        </div>

                        <div
                          className="col-auto btn-collapse collapsed m-3 me-5"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${index + 1}`}
                          aria-expanded="false"
                        >
                          <i className="fas fa-chevron-down" style={{ color: '#eda340' }} />
                        </div>
                      </div>

                      <div className="row gx-3 cursor-pointer collapse" id={`collapse${index + 1}`}>
                        {
                          item.notes.map((data, key) => (

                            <div
                              className="bg-card-filed"
                              style={{
                                width: '100%',
                                marginBottom: 2,
                                backgroundColor: '#424242',
                                position: 'relative',
                                padding: 10
                              }}
                              key={`${index + 1}-${key + 1}`}
                            >
                              <div
                                className="row gx-3 cursor-pointer"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse-${index + 1}-${key + 1}`}
                              >
                                <div className="col">
                                  <div className="ms-4">{data.NoteTitle} </div>
                                </div>

                                <div
                                  className="col-auto btn-collapse collapsed me-2"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#collapse-${index + 1}-${key + 1}`}
                                  aria-expanded="false"
                                >
                                  <i className="fas fa-chevron-down" style={{ color: '#eda340' }} />
                                </div>

                                <div className="col-auto">
                                  <Link onClick={() => this._onEditsurgeonNote(data, item.SurgeonName)} className="link-edit">
                                    <i className="far fa-edit cursor-pointer" />
                                  </Link>
                                </div>

                              </div>

                              <div className="row gx-3 cursor-pointer collapse" id={`collapse-${index + 1}-${key + 1}`}>
                                <div className="col">
                                  {/* eslint-disable react/no-danger */}
                                  <div
                                    className="ms-4"
                                    style={{ padding: '10px', border: '2px solid #666', marginTop: '10px' }}
                                    dangerouslySetInnerHTML={{ __html: data.Note }}
                                  />
                                  {/* eslint-enable react/no-danger */}
                                </div>
                              </div>
                            </div>
                          ))
                        }
                      </div>
                    </div>
                  )) : <p className="text-center mt-5">No Surgeon Notes Found.</p>
              }

            </div>

          </div>
        </section>
      </section>
    );
  }
}

export default withOnline(
  withGoBack(
    withNotify(
      withLoader(
        withUpdatedRoute(
          withSurgeonNotes(
            SurgeonNotes
          )
        )
      )
    )
  )
);
